import 'owl.carousel'
import 'owl.carousel/dist/assets/owl.carousel.css'
import '@vimeo/player'
import './lib/images'
import './lib/icons'
import OneTrust from './lib/onetrust'
import Clicks from './lib/clicks'
import Forms from './lib/forms'
import Search from './lib/search'
import EqualHeights from './lib/equal-heights'
import Sliders from './lib/sliders.js'
import Browser from './lib/browser.js'
import smoothScroll from './lib/smooth-scroll.js'
import overlay from './lib/overlay'
import signup from './lib/sign-up'
import StatCounter from './lib/stat-counter'
import scrollTop from './lib/scroll-top'
import sticky from './lib/sticky'
import VideoFallback from './lib/video-fallback'
import VideoPopup from './lib/video-popup'
import StatPercentageBar from './lib/stat-percentage-bar'
import Sustainability from './lib/sustainability'
import EnterView from './lib/enter-view'
import Accordion from './lib/accordion.js'
import StepByStepAccordion from './lib/step-by-step-accordion.js'
import AccessibleVideo from './lib/accessible-video.js'
import MediaCentre from './lib/media-centre'
import Cards from './lib/cards'
import PinnedForm from './lib/pinned-form'

require('../css/app.scss')

OneTrust()
Clicks()
Forms()
EqualHeights()
Sliders()
Search()
Browser()
smoothScroll()
overlay()
signup()
scrollTop()
StatCounter()
sticky()
VideoFallback()
VideoPopup()
StatPercentageBar()
Sustainability()
EnterView()
Accordion()
StepByStepAccordion()
AccessibleVideo()
MediaCentre()
Cards()
PinnedForm()
